import {
  startTransition,
  useCallback,
  useEffect,
  useRef,
  useState
} from "react";

export function useScrollSpy(
  sectionRefs: {
    id: string;
  }[],
  onSectionSelected?: (sectionId: string | undefined) => void
): string | undefined {
  const [visibleSection, setVisibleSection] = useState<string | undefined>(
    undefined
  );
  const scrollEndTimeoutRef = useRef<NodeJS.Timeout>();

  const scollEnded = useCallback(() => {
    window.clearTimeout(scrollEndTimeoutRef.current);

    scrollEndTimeoutRef.current = setTimeout(() => {
      onSectionSelected?.(visibleSection);
    }, 100);
  }, [onSectionSelected, visibleSection]);

  useEffect(() => {
    const observe = () => {
      const rootElement = document.getElementsByTagName("html")[0];

      const selected = sectionRefs.find(({ id }) =>
        currentActiveElement(id, rootElement)
      );

      if (selected && selected.id !== visibleSection) {
        setVisibleSection(selected.id);
      } else if (!selected && visibleSection) {
        setVisibleSection(undefined);
      }
    };

    startTransition(() => {
      observe();
    });

    window.addEventListener("scroll", observe);
    window.addEventListener("resize", observe);
    window.addEventListener("orientationchange", observe);
    window.addEventListener("scroll", scollEnded, false);

    return () => {
      window.removeEventListener("scroll", observe);
      window.removeEventListener("resize", observe);
      window.removeEventListener("orientationchange", observe);
      window.removeEventListener("scroll", scollEnded);
    };
  }, [sectionRefs, visibleSection, scollEnded]);

  useEffect(() => {
    return () => window.clearTimeout(scrollEndTimeoutRef.current);
  }, []);

  return visibleSection;
}

const currentActiveElement = (
  id: string,
  rootElement: HTMLElement
): boolean => {
  const element = document.getElementById(id);
  if (element) {
    const offset =
      parseInt(getComputedStyle(rootElement).scrollPaddingTop, 10) + 1;

    const clientRect = element.getBoundingClientRect();
    const topOffset = clientRect.top - (offset || 0);
    const bottomOffset = clientRect.bottom - (offset || 0);

    return topOffset <= 0 && bottomOffset >= 0;
  }

  return false;
};
